import { useMemo, Fragment } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { ChevronRight, Home } from 'lucide-react'

const ROUTE_LABELS: Record<string, string> = {
  dashboard: 'Dashboard',
  attendance: 'Asistencia',
  sales: 'Ventas',
  crm: 'CRM',
  stock: 'Stock',
  master: 'Master Admin',
  employees: 'Empleados',
  records: 'Registros',
  upload: 'Importar',
  clients: 'Clientes',
  professionals: 'Profesionales',
  appointments: 'Calendario',
  reports: 'Reportes',
  products: 'Productos',
  movements: 'Movimientos',
  documentation: 'Documentación',
}

export function Breadcrumb() {
  const { pathname } = useLocation()

  const segments = useMemo(() => {
    const parts = pathname.split('/').filter(Boolean)
    return parts.map((part, index) => {
      const path = '/' + parts.slice(0, index + 1).join('/')
      const label = ROUTE_LABELS[part] || part.charAt(0).toUpperCase() + part.slice(1)
      const isLast = index === parts.length - 1
      return { path, label, isLast }
    })
  }, [pathname])

  if (segments.length === 0) return null

  return <nav aria-label="Breadcrumb" className="hidden sm:flex items-center gap-1.5 text-sm">
      <Link
        to="/dashboard"
        className="text-surface-400 dark:text-surface-500 hover:text-surface-600 dark:hover:text-surface-300 transition-colors"
      >
        <Home className="h-4 w-4" />
        <span className="sr-only">Inicio</span>        
      </Link>
      {segments.map((segment) => (
        <Fragment key={segment.path}>
          <ChevronRight className="h-3.5 w-3.5 text-surface-300 dark:text-surface-600 shrink-0" />
          {segment.isLast ? (
            <span className="font-medium text-surface-900 dark:text-surface-50 truncate max-w-[200px]" aria-current="page">
              {segment.label}
            </span>
          ) : (
            <Link
              to={segment.path}
              className="text-surface-400 dark:text-surface-500 hover:text-surface-700 dark:hover:text-surface-300 transition-colors truncate max-w-[200px]"
            >
              {segment.label}
            </Link>
          )}
        </Fragment>
      ))}
    </nav>
}
